import { render, staticRenderFns } from "./ProductPriceUpdateNPH.vue?vue&type=template&id=20a0c480&"
import script from "./ProductPriceUpdateNPH.vue?vue&type=script&lang=js&"
export * from "./ProductPriceUpdateNPH.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports